export const BOTTOM_NAV = {
  UPDATE_ACTIVE_ITEM: 'UPDTE_ACTIVE_ITEM'
};
